import Vue from 'vue';
import Vuex from 'vuex';
import enumList from '@/store/enum';
import alert from '@/store/alert';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    enumList,
    alert,
  },
  state: {
    // @const {Object} api api 實體
    api: undefined,
  },
  mutations: {
    // 設定 $api 實體
    SET_API_TO_STROE(state, api) {
      state.api = api;
    },
  },
  actions: {
    // 取得 $api 實體
    setApiToStore({ commit }, api) {
      commit('SET_API_TO_STROE', api);
    },
  },
});
export default store;
